import VirtualTable from './VirtualTable';
export default VirtualTable;


// WEBPACK FOOTER //
// ./src/components/VirtualTable/index.js